import { fetchAIAgentDataWithAuth } from '@shared/utils/auth';

// Получение Twitter Hype Coins
export const apiGetTwitterHype = async () => {
  const url = `https://dropsmint.com/api/ai-agent/mindshares/`;
  const options = { method: 'GET' };
  try {
    const response = await fetchAIAgentDataWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Сетевая ошибка при получении списка Твиттер Хайп: HTTP error! Status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    throw error;
  }
};
